import { useState } from 'react'
import MFAccordion from '../../ui-components/MFAccordion'
import TextAndInfo from '../../ui-components/TextAndInfo'
import { AdvancedRatios as AdvancedRatiosBottomSheet } from '../../BottomSheetComponents/AdvancedRatios'
import { trackEvent } from '../../../utils/appBridge'
import { EventNames } from '../../../types/misc.types'
import { useMetaDataContext } from '../../../state-management/contexts/MetaDataContext'
import NameValueTable from '../../ui-components/NameValueTable'
import VaulDrawer from '../../BottomSheetComponents/VaulDrawer'

const FUND_INFORMATION_SCREEN_NAME = `MF_L2_Fund_Information`

export const AdvancedRatios = () => {
  const { isin, data } = useMetaDataContext()
  const [isAdvancedRatiosOpen, setIsAdvancedRatiosOpen] = useState(false)
  const [openBottomSheet, setOpenBottomSheet] = useState(false)
  const [bottomSheetContentKey, setBottomSheetContentKey] = useState<any>(null)

  const renderBottomSheetContent = () => {
    switch (bottomSheetContentKey) {
      case 'advancedRatios':
        return (
          <AdvancedRatiosBottomSheet
            onDismiss={() => setOpenBottomSheet((open) => !open)}
            ScreenName={FUND_INFORMATION_SCREEN_NAME}
          />
        )

      default:
        return null
    }
  }
  return (
    <>
      <MFAccordion
        title='Advanced Ratios'
        middleContent={
          <TextAndInfo
            text='Advanced Ratios'
            onInfoClick={(event) => {
              event.stopPropagation()
              setBottomSheetContentKey('advancedRatios')
              setOpenBottomSheet((open) => !open)
            }}
          />
        }
        isExpanded={isAdvancedRatiosOpen}
        onAccordionClick={() => {
          setIsAdvancedRatiosOpen((isAdvancedRatiosOpenPrev) => {
            trackEvent({
              eventName: EventNames.UserClicked,
              payload: {
                eventId: 'Advanced Ratios',
                responseName: isAdvancedRatiosOpenPrev ? 'Collapse' : 'Expand',
                ScreenName: FUND_INFORMATION_SCREEN_NAME,
                fundName: isin,
                screenType: 'MF_L2'
              }
            })
            return !isAdvancedRatiosOpenPrev
          })
        }}
        isBorderTop={true}
      >
        <div className='pb-[32px]'>
          <NameValueTable
            data={[
              { name: 'P/E Ratio', value: `${data?.advancedRatios?.pe?.toFixed(2) ?? '-'}` },
              { name: 'P/B Ratio', value: `${data?.advancedRatios?.pb?.toFixed(2) ?? '-'}` },
              { name: 'Alpha Ratio', value: `${data?.advancedRatios?.alpha?.toFixed(2) ?? '-'}` },
              { name: 'Beta Ratio', value: `${data?.advancedRatios?.beta?.toFixed(2) ?? '-'}` },
              { name: 'Sharpe Ratio', value: `${data?.advancedRatios?.sharpe?.toFixed(2) ?? '-'}` },
              { name: 'Sortino Ratio', value: `${data?.advancedRatios?.sortino?.toFixed(2) ?? '-'}` }
            ]}
            gap={10}
            groupForAccessibility
          />
        </div>
      </MFAccordion>
      <VaulDrawer open={openBottomSheet} setOpen={setOpenBottomSheet}>
        {renderBottomSheetContent()}
        {/* <FundInformationContent onDismiss={() => setOpenBottomSheet((open) => !open)} /> */}
      </VaulDrawer>
    </>
  )
}
